import type { Location } from 'react-router-dom'

/** 模型库首页的查询参数只更新筛选状态；其他页面保持既有的 location.key 重挂载行为。 */
export const getPageTransitionKey = ({ pathname, key }: Pick<Location, 'pathname' | 'key'>) =>
  /^\/home\/?$/.test(pathname) ? pathname : key
